export default class AfiliatePrice {
    constructor(values) {
        // Object.assign(this, values)
        this.id = values.id;
        this.passengerCategory_id = values.passengerCategory;
        this.stretch_id = values.stretch_id;
        this.afiliate_id = values.afiliate_id;
        this.priceNet = values.priceNet;
        this.allowWeb = values.allowWeb;
        this.idaVuelta = values.idaVuelta;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Prices/AfiliatePrice.ts
// module id = 362
// module chunks = 0